import React from 'react';
import PropTypes from 'prop-types';
import { useDebounceForInput } from 'utils';
import { Input, IconButton, InputAdornment } from '@material-ui/core';
import { GlobalSearch as SearchIcon, ClearIcon } from '../Icons';

const SearchField = ({ value, onChange, classes, withDebounce, endIcon, withoutSearchIcon, ...props }) => {
  const [searchValue, setSearchValue] = withDebounce ? useDebounceForInput(onChange, 450, value) : [value, onChange];
  const clearValue = () => setSearchValue('');
  const onChangeValue = (e) => setSearchValue(e.target.value);

  return (
    <Input
      value={searchValue}
      onChange={onChangeValue}
      fullWidth
      classes={{ underline: classes.underline }}
      startAdornment={
        <InputAdornment classes={{ root: classes.searchIcon }} disablePointerEvents>
          {!withoutSearchIcon && <SearchIcon />}
        </InputAdornment>
      }
      endAdornment={
        <React.Fragment>
          {searchValue.length ? (
            <IconButton
              onClick={clearValue}
              classes={{ root: classes.clearButton }}
              data-testid="search-field-clear-value"
            >
              <ClearIcon />
            </IconButton>
          ) : null}
          {endIcon && <div className={classes.endIcon}>{endIcon}</div>}
        </React.Fragment>
      }
      data-testid="search-field-input"
      {...props}
    />
  );
};

SearchField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  classes: PropTypes.objectOf(PropTypes.string),
  withDebounce: PropTypes.bool,
  endIcon: PropTypes.node,
  withoutSearchIcon: PropTypes.bool,
};

SearchField.defaultProps = {
  value: '',
  onChange: () => {},
  classes: {},
  withDebounce: false,
  endIcon: null,
};

export default SearchField;
